












import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  inheritAttrs: false
})
export default class AccessibleDialog extends Vue {
  @Prop({ default: "" }) ariaLabel!: string;

  get dialogRef(): string {
    return `accessible_dialog_${(this as any)._uid}`;
  }

  // Pass all $attrs except aria-label (we handle it ourselves) to v-dialog
  get dialogAttrs(): Record<string, any> {
    const { "aria-label": _, ...rest } = this.$attrs as any;
    return rest;
  }

  get isOpen(): boolean {
    return !!this.$attrs.value;
  }

  @Watch("isOpen")
  onValueChange(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        this.applyAriaLabel();
      });
    }
  }

  mounted() {
    if (this.isOpen) {
      this.$nextTick(() => {
        this.applyAriaLabel();
      });
    }
  }

  private applyAriaLabel() {
    if (!this.ariaLabel) return;
    const ref = this.$refs[this.dialogRef] as any;
    if (ref && ref.$el) {
      const dialogEl = ref.$el.querySelector('[role="dialog"]');
      if (dialogEl) {
        dialogEl.setAttribute("aria-label", this.ariaLabel);
        dialogEl.removeAttribute("aria-labelledby");
      }
    }
  }
}
